import React from 'react';
import { Card, DescriptionTextBox, PaddedBox } from 'src/components/base/container';
import { Divider, PageTitle } from 'src/components/base/styledComponents';
import { SubHeader } from '../styledComponents';

const TermsOfService: React.FC = () => {
  return (
    <PaddedBox marginBottom>
      <Card>
        <PaddedBox>
          <PageTitle center>Terms And Conditions</PageTitle>
          <DescriptionTextBox>
            The following Terms of Access constitute a legal agreement for registered users and visitors who access or
            use the web-based software application provided by Direct Livestock Marketing Systems Inc. ("DLMS"),
            accessible on the Internet and located at http://www.dlms.ca (the "System").
          </DescriptionTextBox>
          <Divider />
          <SubHeader>Acceptance of Conditions</SubHeader>
          <DescriptionTextBox>
            By accessing, browsing or using the System, you represent and warrant that: (i) you have read, understand
            and agree to be bound by the Terms of Access and Privacy Policy (together, the "Agreement"), and all
            applicable laws ("Laws") and agreements governing their use; (ii) you accept and agree to comply with the
            terms and conditions of the Agreement, without limitation or qualification; and (iii) you are duly
            authorized to use the System.
          </DescriptionTextBox>
          <DescriptionTextBox>
            DLMS may at any time revise these Terms of Access by updating this posting. Users agree to be bound by such
            revisions, and agree to regularly revisit this page to review the current Terms of Access. Your continued
            use of the System after posting shall constitute your acceptance of and agreement to be bound by the amended
            Agreement. If you do not agree to any amendments, you agree to terminate your use and access to the System.
          </DescriptionTextBox>
          <SubHeader>Acceptable Use</SubHeader>
          <DescriptionTextBox>
            You agree to: (a) use the System only for lawful purposes and in compliance with all applicable Laws,
            including without limitation, any export control Laws, antitrust and competition Laws and privacy Laws; (b)
            use the System, as an authorized user, only for the purposes set forth in the Agreement; (c) take all
            necessary precautions to ensure that all user content or other information, data or material provided by you
            does not contain any items, links, descriptions or information prohibited in the Agreement or these Terms of
            Access; (d) take all precautions necessary to maintain the secrecy and security of your Passwords and user
            IDs and be solely responsible for any use or misuse of your Passwords and user IDs; and (e) comply with any
            and all applicable rules governing transactions on and through the System.
          </DescriptionTextBox>
          <SubHeader>Prohibited Activities</SubHeader>
          <DescriptionTextBox>
            You agree not to: (a) use any systems or techniques, or engage in any activities or practices that disrupt,
            circumvent or otherwise interfere with the operation of the System or DLMS's right to or interest in any
            fees; (b) violate the privacy rights of other users; (c) allow or permit access to or use of the System or
            any component thereof by any third parties (who are not authorized users), or for any unlawful purpose; and
            (d) engage in any conduct that violates the Agreement or these Terms of Access or that, in DLMS's sole and
            absolute discretion, restricts, inhibits or impacts any other user from using or enjoying the System.
          </DescriptionTextBox>
          <SubHeader>No Interference with the System</SubHeader>
          <DescriptionTextBox>
            You shall not disturb or interfere with the operation of the DLMS System in any manner, including without
            limitation, by imposing an unreasonable or disproportionate burden on the network, software or hardware
            infrastructure of the System.
          </DescriptionTextBox>
          <SubHeader>Delays of Services</SubHeader>
          <DescriptionTextBox>
            Neither DLMS nor any of its licensors (including their officers, directors, employees, affiliates, agents,
            representatives or subcontractors) shall be liable for any loss or liability resulting, directly or
            indirectly, from delays or interruptions due to electronic or mechanical equipment failures, telephone
            interconnect problems, defects, weather, strikes, walkouts, fire, acts of God, riots, armed conflicts, acts
            of war or other like causes. DLMS shall have no responsibility to provide you access to the System while
            interruption of the System, due to any such cause, shall continue.
          </DescriptionTextBox>
          <SubHeader>Information Accuracy</SubHeader>
          <DescriptionTextBox>
            Although the contents of the System are deemed reliable when posted, DLMS cannot guarantee this information
            to be current, accurate or complete. The information is subject to modification and updating from time to
            time without notice.
          </DescriptionTextBox>
          <SubHeader>Content</SubHeader>
          <DescriptionTextBox>
            The information on the System is not intended to provide professional advice including, without limitation,
            financial, legal, accounting or tax advice, and should not be relied upon in this regard.
          </DescriptionTextBox>
          <SubHeader>No Warranties</SubHeader>
          <DescriptionTextBox>
            DLMS, its subsidiaries, affiliated companies, licensors, its officers, directors, employees or agents
            (collectively "DLMS Parties") provide the System on an "as is, where is" basis and do not make any express
            or implied warranties, representations, endorsements or conditions with respect to the System or the
            Information, including without limitation, warranties as to merchantability, operation, non-infringement,
            usefulness, completeness, accuracy, currentness, reliability and fitness for a particular purpose. Further,
            DLMS Parties do not represent or warrant that the System will be available and meet your requirements, that
            access will be uninterrupted, that there will be no delays, failures, errors or omissions or loss of
            transmitted information, that no viruses or other contaminating or destructive properties will be
            transmitted or that no damage will occur to your computer system. You have sole responsibility for adequate
            protection and backup of data and/or equipment and to take reasonable and appropriate precautions to scan
            for computer viruses or other destructive properties.
          </DescriptionTextBox>
          <SubHeader>No Liability</SubHeader>
          <DescriptionTextBox>
            DLMS Parties, or any persons associated with the creation of this System, are NOT responsible in any manner
            whatsoever for any harm, loss or damage that may arise in connection with or through the use of the System
            including, without limitation, any direct, indirect, special, third party, consequential, exemplary or
            punitive damages, howsoever caused arising out of or in connection with your use of or inability to use the
            System or the Information, or any action or decision made by you in reliance on the System or the
            Information, or any unauthorized use or reproduction of the System or the Information, even if DLMS has been
            advised of the possibility of these damages.
          </DescriptionTextBox>
          <SubHeader>Trademarks and Copyrights</SubHeader>
          <DescriptionTextBox>
            Certain names, words, titles, phrases, logos, icons, graphics or designs or other content in the pages of
            the System are trade names or trade-marks owned by DLMS or its subsidiaries, or trade names or trade-marks
            licensed to them. The Information is for your personal use only. Any unauthorized downloading,
            re-transmission, or other copying or modification of DLMS's trade-marks, patents, copyrights and/or the
            contents of the System may be a violation of any federal or other law that may apply to trade-marks, patents
            and/or copyrights and could subject the copier to legal action. The Information is protected under the
            copyright laws of Canada and other countries. Unless otherwise specified, no one has permission to copy,
            redistribute, reproduce, republish, store in any medium, re-transmit, modify or make public or commercial
            use of, in any form, the Information.
          </DescriptionTextBox>
          <SubHeader>Internet E-Mail</SubHeader>
          <DescriptionTextBox>
            Any unprotected E-Mail communication over the Internet is, as with communication via any other medium (e.g.
            cellular phones, post office mail), not confidential, subject to possible interception or loss, and is also
            subject to possible alteration. DLMS is not responsible for and will not be liable to you or any one else
            for any damages in connection with E-Mail sent by you to DLMS or an E-Mail sent by DLMS to you at your
            request. Any communication transmitted to us by electronic mail becomes the property of DLMS or its
            affiliates and may be used for any purpose. DLMS is free to use any idea contained in any communication sent
            to us for any purpose whatsoever, including, but not limited to, developing, manufacturing and marketing
            products using such information.
          </DescriptionTextBox>
          <SubHeader>Links/Software</SubHeader>
          <DescriptionTextBox>
            The System may provide links or references to other sites. Links from or to web sites outside the System are
            meant for convenience only. Unless otherwise expressly stated, DLMS does not review, endorse, approve or
            control, and is not responsible for any sites linked from or to the System, the content of those sites, the
            third parties named therein, or their products and services. Linking to any other site is at your sole risk
            and DLMS will not be responsible or liable for any damages in connection with linking. Links to downloadable
            software sites are for convenience only and DLMS is not responsible or liable for any difficulties or
            consequences associated with downloading the software. Use of any downloaded software is governed by the
            terms of the license agreement, if any, which accompanies or is provided with the software.
          </DescriptionTextBox>
          <SubHeader>Password Disclosure</SubHeader>
          <DescriptionTextBox>
            If at any time you are issued a userid and/or password and you learn or suspect that such identifiers have
            been disclosed or otherwise made known to any person other than yourself, you agree to immediately notify
            DLMS and to confirm such notice in writing within seventy-two (72) hours. Upon receiving such notice, DLMS
            will assign a new userid and/or password to you within a reasonable period of time. Re-issuance and
            reactivation of such identifiers may be subject to DLMS's standard charges.
          </DescriptionTextBox>
          <SubHeader>No Conflicting Terms</SubHeader>
          <DescriptionTextBox>
            If there is any conflict between this Agreement and any help text, manuals, or other documents, this
            Agreement shall govern, whether such other documents are prior to or subsequent to this Agreement, or are
            signed or acknowledged by DLMS Parties.
          </DescriptionTextBox>
          <SubHeader>Termination of Access</SubHeader>
          <DescriptionTextBox>
            DLMS shall have the right to terminate, limit or suspend your access to all or any part of the System at any
            time, with or without notice, for any reason, including without limitation, for any conduct that DLMS
            believes is in violation of these Terms of Access or any applicable Laws or is harmful to the interests of
            another user, any third party or the System.
          </DescriptionTextBox>
          <SubHeader>Jurisdiction</SubHeader>
          <DescriptionTextBox>
            DLMS administers the System from its offices in Canada . The Terms of Access, Privacy Policy and this
            Agreement regarding the System will be governed by and construed in accordance with the Laws of the Province
            of Alberta and the Laws of Canada applicable therein, without giving effect to any principles of conflicts
            of laws. All disputes, controversies or claims arising out of or in connection with the System shall be
            submitted to and be subject to the jurisdiction of the courts of the Province of Alberta. You submit and
            attorn to the exclusive jurisdiction of the courts of the Province of Alberta to finally adjudicate or
            determine any suit, action or proceeding arising out of or in connection with the System.
          </DescriptionTextBox>
          <SubHeader>Entire Agreement</SubHeader>
          <DescriptionTextBox>
            This Agreement is complete and shall become effective and enforceable at the time you agree to it which will
            be evidenced by you accessing or using the System or Information. This Agreement constitutes the entire
            agreement between the parties, and no other agreement, written or oral, exists between you and DLMS.
          </DescriptionTextBox>
        </PaddedBox>
      </Card>
    </PaddedBox>
  );
};

export default TermsOfService;
